// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"95c31750","652":"3a2f33f0"}[chunkId] + ".chunk.css";
};